import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { FaqHelpEvent } from './faq-help-events';

@Injectable({ providedIn: 'root' })
export class FaqHelpEventProvider extends DomainEventProvider<FaqHelpEvent> {}
